export default "__VITE_ASSET__CDurnneU__"